import { render, staticRenderFns } from "./couponPoolManageList.vue?vue&type=template&id=19dacf5a&scoped=true"
import script from "./couponPoolManageList.vue?vue&type=script&lang=js"
export * from "./couponPoolManageList.vue?vue&type=script&lang=js"
import style0 from "./couponPoolManageList.vue?vue&type=style&index=0&id=19dacf5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dacf5a",
  null
  
)

export default component.exports